module.exports = __webpack_public_path__ + "img/t-xidao.prt.6fb912ae.jpg";